import Loading from '../../../Common/Loading';
import { useIdentificationChartsDataContext } from './hooks/useIdentificationChartsDataContext';
import { Indicators } from './Indicators';
import { WeightLessThan25kg } from './WeightLessThan25kg';
import { LiveBirthsWithAnomalies } from './LiveBirthsWithAnomalies';
import { WeightLess25kgxLess6ConsultationsPrenatal } from './WeightLess25kgxLess6ConsultationsPrenatal';
import { BirthWeigth } from './BirthWeight';
import { Gender } from './Gender';
import { Apgar1Minute } from './Apgar1Minute';
import { Apgar5Minutes } from './Apgar5Minutes';

export const Charts = () => {
    const { isLoading } = useIdentificationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Indicators />
            <div className="charts-side-by-side-dashboards">
                <WeightLessThan25kg />
                <LiveBirthsWithAnomalies />
                <WeightLess25kgxLess6ConsultationsPrenatal />
            </div>
            <div className="charts-side-by-side-dashboards">
                <BirthWeigth />
                <Gender />
            </div>
            <div className="charts-side-by-side-dashboards">
                <Apgar1Minute />
                <Apgar5Minutes />
            </div>
        </>
    );
};
